import "core-js/modules/es.object.to-string.js";
import { getCaptchaRecordList as _getCaptchaRecordList } from '@/services/customer/captchaRecordList';
export default {
  name: 'captchaRecordList',
  components: {},
  i18n: require('./i18n-captchaRecordList'),
  data: function data() {
    return {
      sendTime: [],
      account: '',
      page: 1,
      size: 20,
      total: 0,
      dataList: [],
      isTableLoading: false,
      columns: [{
        //发送时间
        title: this.$t('captchaRecordList.sendTime'),
        dataIndex: 'sendTime',
        key: 'sendTime',
        width: '12%'
      },
      //发送场景
      {
        title: this.$t('captchaRecordList.sendScene'),
        width: '14%',
        dataIndex: 'sendAction',
        key: 'sendAction',
        scopedSlots: {
          customRender: 'sendAction' //自定义表格里面的内容
        }
      }, {
        //邮箱电话
        title: this.$t('captchaRecordList.emailOrPhone'),
        dataIndex: 'userAccount',
        key: 'userAccount',
        width: '14%',
        ellipsis: true
      },
      // 顾客信息
      {
        title: this.$t('captchaRecordList.erpCustomerInfo'),
        dataIndex: 'erpCustomerInfo',
        key: 'erpCustomerInfo',
        width: '15%',
        scopedSlots: {
          customRender: 'erpCustomerInfo' //自定义表格里面的内容
        }
      }, {
        //发送内容
        title: this.$t('captchaRecordList.sendContent'),
        dataIndex: 'messagecode',
        key: 'messagecode',
        width: '40%',
        scopedSlots: {
          customRender: 'messagecode' //自定义表格里面的内容
        }
      },
      //状态
      {
        title: this.$t('captchaRecordList.sendResult'),
        dataIndex: 'sendResult',
        key: 'sendResult',
        width: '5%',
        scopedSlots: {
          customRender: 'sendResult' //自定义表格里面的内容
        }
      }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    //加载列表数据
    loadData: function loadData() {
      var self = this;
      self.page = 1;
      var param = {
        page: self.page,
        size: self.size,
        account: self.account,
        startDate: self.sendTime[0],
        endDate: self.sendTime[1]
      };
      self.getCaptchaRecordList(param);
    },
    getCaptchaRecordList: function getCaptchaRecordList(param) {
      var self = this;
      self.isTableLoading = true;
      _getCaptchaRecordList(param).then(function (res) {
        if (res.data.code == 200) {
          self.dataList = res.data.data.list;
          self.total = res.data.data.total;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    // 点击翻页按钮
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      var self = this;
      self.page = pagination.current;
      self.size = pagination.pageSize;
      var param = {
        page: pagination.current,
        size: pagination.pageSize,
        account: self.account,
        startDate: self.sendTime[0],
        endDate: self.sendTime[1]
      };
      self.getCaptchaRecordList(param);
    }
  }
};